import { useState, useEffect } from 'react';
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import { api, getToken, clearToken } from '../api/client';
import ResourceManager from './ResourceManager';
import SiteSettingsManager from './SiteSettingsManager';
import SponsorshipManager from './SponsorshipManager';
import ChangePassword from './ChangePassword';

const NAV_ITEMS = [
  { path: 'hero-images', label: 'Images bannière' },
  { path: 'features', label: 'Expertise' },
  { path: 'formation-images', label: 'Images formations' },
  { path: 'products', label: 'Produits' },
  { path: 'partners', label: 'Ils parlent de nous' },
  { path: 'testimonials', label: 'Témoignages' },
  { path: 'sponsorship', label: 'Parrainage' },
  { path: 'settings', label: 'Paramètres du site' },
  { path: 'account', label: 'Compte' }
];

function AdminLayout() {
  const [status, setStatus] = useState('checking');
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      setStatus('unauthenticated');
      return;
    }
    api.me().then(() => setStatus('authenticated')).catch(() => {
      clearToken();
      setStatus('unauthenticated');
    });
  }, []);

  const handleLogout = () => {
    clearToken();
    navigate('/admin/login');
  };

  if (status === 'checking') {
    return <div className="admin-loading">Chargement…</div>;
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <h1>SENLEM</h1>
        <nav>
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.path} to={`/admin/${item.path}`} className={({ isActive }) => isActive ? 'active' : ''}>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <button className="admin-btn admin-logout" onClick={handleLogout}>Se déconnecter</button>
        <a className="admin-view-site" href="/" target="_blank" rel="noreferrer">Voir le site ↗</a>
      </aside>
      <main className="admin-content">
        <Routes>
          <Route index element={<Navigate to="/admin/hero-images" replace />} />
          <Route
            path="hero-images"
            element={<ResourceManager resource="hero-images" title="Images bannière" uploadSection="hero"
              fields={[
                { key: 'url', label: 'Image ou vidéo', type: 'media', typeKey: 'media_type' },
                { key: 'media_type', label: 'Type', type: 'hidden' },
                { key: 'alt', label: 'Texte alternatif', type: 'text' }
              ]} />}
          />
          <Route
            path="features"
            element={<ResourceManager resource="features" title="Notre Expertise"
              fields={[{ key: 'title', label: 'Titre', type: 'text' }, { key: 'description', label: 'Description', type: 'textarea' }, { key: 'icon', label: 'Icône (emoji)', type: 'text' }]} />}
          />
          <Route
            path="formation-images"
            element={<ResourceManager resource="formation-images" title="Images formations" uploadSection="formation"
              fields={[{ key: 'url', label: 'Image', type: 'image' }, { key: 'alt', label: 'Texte alternatif', type: 'text' }]} />}
          />
          <Route
            path="products"
            element={<ResourceManager resource="products" title="Produits" uploadSection="products"
              fields={[{ key: 'picture_url', label: 'Photo', type: 'image' }, { key: 'title', label: 'Titre', type: 'text' }, { key: 'price', label: 'Prix', type: 'text' }]} />}
          />
          <Route
            path="partners"
            element={<ResourceManager resource="partners" title="Ils parlent de nous" uploadSection="partners"
              fields={[{ key: 'logo_url', label: 'Logo', type: 'image' }, { key: 'description', label: 'Description', type: 'textarea' }, { key: 'link', label: 'Lien', type: 'text' }]} />}
          />
          <Route
            path="testimonials"
            element={<ResourceManager resource="testimonials" title="Témoignages" uploadSection="testimonials"
              fields={[{ key: 'image_url', label: 'Drapeau / image', type: 'image' }, { key: 'name', label: 'Pays', type: 'text' }, { key: 'role', label: 'Rôle', type: 'text' }, { key: 'text', label: 'Témoignage', type: 'textarea' }, { key: 'url', label: 'Lien', type: 'text' }]} />}
          />
          <Route path="sponsorship" element={<SponsorshipManager />} />
          <Route path="settings" element={<SiteSettingsManager />} />
          <Route path="account" element={<ChangePassword />} />
        </Routes>
      </main>
    </div>
  );
}

export default AdminLayout;
